import { storeAPI } from '../api/storeAPI.js';
import { orgAPI } from '../api/orgAPI.js';
import { getPostLoginPath } from '../constants/storeModes.js';

/**
 * Resolve where to send the user after auth (password gate, billing, store pick, or home).
 */
export async function resolvePostLoginPath({ passwordChangeRequired = false } = {}) {
    if (passwordChangeRequired) {
        return getPostLoginPath({ passwordChangeRequired: true, storesCount: 0 });
    }

    let storesCount = 0;
    let billingStatus;

    try {
        const { data } = await storeAPI.list();
        const stores = Array.isArray(data?.stores) ? data.stores : [];
        storesCount = stores.length;
    } catch {
        storesCount = 0;
    }

    try {
        const { data } = await orgAPI.getBilling();
        billingStatus = data?.billing?.status;
    } catch {
        billingStatus = undefined;
    }

    return getPostLoginPath({
        passwordChangeRequired: false,
        storesCount,
        billingStatus,
    });
}
